import { SubSink } from 'subsink';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  OnDestroy,
} from '@angular/core';
import * as _ from 'lodash';

import { ApprovalsService } from '../../services/approvals.service';
import { AuthUser, AuthService } from '@monorepo/ui/auth';
import { BookingStatus } from 'apps/signgaze/src/app/models';

@Component({
  selector: 'signgaze-approvals-container',
  templateUrl: './approvals-container.component.html',
  styleUrls: ['./approvals-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApprovalsContainerComponent implements OnInit, OnDestroy {
  private subs = new SubSink();
  public approvals: any[];
  public isSigngazeAdmin: boolean;

  constructor(
    private approvalsService: ApprovalsService,
    private authService: AuthService,
    private cdRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.subs.sink = this.authService.user.subscribe({
      next: (user: AuthUser): void => {
        if (user) {
          this.isSigngazeAdmin = user.isAdmin;
          this.getApprovalRequests();
        }
      },
    });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  public getApprovalRequests() {
    this.subs.sink = this.approvalsService
      .getApprovalRequests(this.isSigngazeAdmin)
      .subscribe((bookings: any[]) => {
        this.approvals = [];
        if (bookings && bookings.length > 0) {
          this.approvals = bookings;
        }
        this.cdRef.detectChanges();
      });
  }

  public approve(itemIndex) {
    const booking = this.approvals[itemIndex];
    if (this.isSigngazeAdmin) {
      booking.status = BookingStatus.ADMIN_APPROVED;
    } else {
      booking.status = BookingStatus.OWNER_APPROVED;
    }
    this.approvalsService.updateBooking(booking);
  }

  public reject(itemIndex) {
    const booking = this.approvals[itemIndex];
    booking.status = BookingStatus.REJECTED;
    this.approvalsService.updateBooking(booking);
  }
}
